export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14788.a9e27aa3.jpg";